import styled, { css } from 'styled-components';

import { Skeleton } from '@/ui/Skeleton';

const ContainerStyled = styled.div<{ $width?: number }>`
  aspect-ratio: 210 / 297;
  background-color: ${({ theme }) => theme.colors.neutral.background};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  padding: 32px;

  ${({ $width }) =>
    $width !== undefined
      ? css`
          width: ${$width}px;
        `
      : css`
          /* Fill the available height at A4 ratio and provide our own shadow when unframed. */
          height: 100%;
          width: auto;
          max-width: 100%;
          ${({ theme }) => theme.shadow.primary[32]}
        `}
`;

type JourneyCertificatePreviewSkeletonProps = {
  /**
   * Explicit width in px. Pass this when the skeleton sits inside its own frame/shadow container
   * (e.g. next to a rendered PDF) so it matches the PDF size exactly and renders no shadow of its
   * own. When omitted, the skeleton fills its parent's height at A4 ratio with its own drop shadow.
   */
  width?: number;
};

/** A4-shaped placeholder shown while a certificate PDF preview is loading. */
export const JourneyCertificatePreviewSkeleton = ({ width }: JourneyCertificatePreviewSkeletonProps): JSX.Element => (
  <ContainerStyled $width={width} aria-hidden>
    <Skeleton width={240} height={20} />
    <Skeleton width={180} height={16} />
    <Skeleton width={280} height={16} />
  </ContainerStyled>
);
